
define('ldsh!modules/includes_editor/templates/list_item_editable', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<span class="txt">' +
((__t = ( name )) == null ? '' : __t) +
'</span>\n<input type="text" class="ed-rename-item js-item-name" value="' +
((__t = ( editableName )) == null ? '' : __t) +
'">\n<p class="ed-msg-error" data-i18n="includeEditor.existingListItemName">Ese nombre ya existe</p>\n<span class="ed-icon ' +
((__t = ( editItemName ? 'ri-save-3-line' : 'ri-pencil-line' )) == null ? '' : __t) +
' js-edit" aria-hidden="true">\n</span>\n';

}
return __p
};});

